module.exports = __webpack_public_path__ + "static/media/luggage-cart.dbf74050.svg";